import { Scope } from "@corpuscomplete/core/common/scope";
import { MealPlanningSessionList } from "@corpuscomplete/core-ui/nutrition/meal-planning-session/list";
import { useAuth } from "@corpuscomplete/web/auth/hooks";
import { MealPlanningSessionsPage } from "@corpuscomplete/web/modules/nutrition/meal-planning-session/pages/meal-planning-sessions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/meal-planning-sessions/")({
  loader: async ({ context: { zero, actor } }) => {
    if (!zero) return;
    MealPlanningSessionList.preload(zero, { scopeId: actor.userId });
  },
  component: () => {
    const { userId } = useAuth();
    return <MealPlanningSessionsPage scope={Scope.personal(userId)} />;
  },
});
